import { forwardRef } from "react";
import { Link as RouterLink, NavLink as RouterNavLink, useLocation } from "react-router-dom";

export const SUPPORTED_LANGS = ["de"];

/** "en" at the root, "de" under `/de` — pathname is the single source of truth. */
export function useActiveLang() {
  const { pathname } = useLocation();
  return pathname === "/de" || pathname.startsWith("/de/") ? "de" : "en";
}

/** Prefixes an absolute path with the active `/de` segment, if any. */
export function withLocale(to, lang) {
  if (lang !== "de" || typeof to !== "string" || !to.startsWith("/")) return to;
  return `/de${to}`;
}

/** Drop-in `react-router-dom` `Link` that stays inside the active locale. */
export const Link = forwardRef(function Link({ to, ...rest }, ref) {
  const lang = useActiveLang();
  return <RouterLink ref={ref} to={withLocale(to, lang)} {...rest} />;
});

/** Drop-in `react-router-dom` `NavLink` that stays inside the active locale. */
export const NavLink = forwardRef(function NavLink({ to, ...rest }, ref) {
  const lang = useActiveLang();
  return <RouterNavLink ref={ref} to={withLocale(to, lang)} {...rest} />;
});
